/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Brand_Home_AriaInputs */



/**
* | output |
* | --- |
* | "oneAI — go to start page" |
*
* @param {Partner_Brand_Home_AriaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_brand_home_aria = /** @type {((inputs?: Partner_Brand_Home_AriaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Brand_Home_AriaInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("oneAI — zur Startseite")
	return /** @type {LocalizedString} */ ("oneAI — go to start page")
});